<template>
  <div class="bot-section">
    <div class="bot-toolbar">
      <div class="bot-toolbar__actions">
        <button
          type="button"
          class="btn btn-sm bot-action bot-action--primary"
          @click="createOrder()"
        >
          <i class="fas fa-box-open"></i>
          <span>Замовлення</span>
        </button>
        <button
          type="button"
          class="btn btn-sm bot-action bot-action--tailoring"
          @click="createOrder('Wholesale', 'Tailoring')"
        >
          <i class="fas fa-tools"></i>
          <span>Відшив</span>
        </button>
      </div>
      <form
        v-if="this.fields.length > 0"
        class="bot-filter"
        @submit.prevent="addFilter(filter)"
      >
        <select
          v-model="filter.field"
          class="form-control bot-control"
        >
          <option
            v-for="option in fields"
            :key="option.field"
            :value="option.field"
          >
            {{ option.name }}
          </option>
        </select>
        <select
          v-model="filter.type"
          class="form-control bot-control"
        >
          <option
            v-for="option in typesFilterfilter(filter)"
            :key="option.value"
            :value="option.value"
          >
            {{ option.name }}
          </option>
        </select>
        <input
          v-if="currentInputType(filter) != 'lookup'"
          v-model="filter.value"
          :type="currentInputType(filter)"
          class="form-control text-center bot-control"
          required
        >
        <select
          v-else
          v-model="filter.value"
          class="form-control bot-control"
          required
        >
          <option
            v-for="option in fields.find((x) => x.field == filter.field).lookup"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </option>
        </select>
        <button
          :disabled="!(!!filter.value && !!filter.field && !!filter.type) &&
            currentInputType(filter) != 'checkbox'
            "
          class="btn btn-sm bot-action bot-action--filter"
        >
          {{ $filters.localize("main.submitFilter") }}
        </button>
      </form>
    </div>

    <div
      v-if="filters.length > 0"
      class="bot-active-filters"
    >
      <div
        v-for="(item, index) in filters"
        :key="index"
        class="bot-filter-chip"
      >
        <button
          type="button"
          class="bot-filter-chip__remove"
          @click.prevent="removeFilter(index)"
        >
          <i class="fas fa-times"></i>
        </button>
        <label class="bot-filter-chip__label">
          {{ getFilterString(item) }}
        </label>
        <select
          v-model="item.type"
          class="form-control bot-control"
        >
          <option
            v-for="option in typesFilterfilter(item)"
            :key="option.value"
            :value="option.value"
          >
            {{ option.name }}
          </option>
        </select>

        <input
          v-if="currentInputType(item) != 'lookup'"
          v-model="item.value"
          :type="currentInputType(item)"
          class="form-control text-center bot-control"
          required
        >
        <select
          v-else
          v-model="item.value"
          class="form-control bot-control"
          required
        >
          <option
            v-for="option in fields.find((x) => x.field == item.field).lookup"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="bot-table-card">
      <table class="table table-hover bot-table">
        <thead>
          <tr>
            <th
              v-for="header in headers"
              :key="header.field"
              class="text-center"
            >
              {{ header.name }}
            </th>
            <th class="text-center">{{ $filters.localize("tableColumns.common.ttn") }}</th>
            <th class="text-center">{{ $filters.localize("tableColumns.common.margin") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) in rowsData"
            :key="index"
          >
            <td
              v-for="header in headers"
              :key="`${index}-${header.field}`"
              :class="[
                'text-center',
                'bot-table__link-cell',
                header.class ? header.class : '',
                { 'bot-table__chip-cell': isChipHeader(header) },
              ]"
              @click="openOrder(row)"
              @click.middle.prevent="openOrder(row, true)"
            >
              <span
                v-if="header.field === 'fulfillmentKind'"
                class="bot-order-chip"
                v-bind:class="getFulfillmentKindClass(row)"
              >
                {{ formatFulfillmentKind(row) }}
              </span>
              <span
                v-else-if="header.field === 'status.name'"
                class="bot-order-chip"
                v-bind:class="getStatusClass(row)"
              >
                {{ getRowValue(row, header) }}
              </span>
              <span v-else>
                {{ getRowValue(row, header) }}
              </span>
            </td>
            <td class="text-center">
              {{ getRowValue(row, { field: "ttn", name: "ТТН" }) }}
            </td>
            <td class="text-center">
              {{ formatCurrency(getMargin(row)) }}
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="rowsData.length === 0"
        class="bot-empty"
      >
        {{ $filters.localize("main.notdata") }}
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import rows from "@/mixins/rows.js";

export default {
  name: "OrdersBotPage",
  mixins: [rows],
  computed: {
    rowsData: {
      get() {
        return [...this.rows].sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      },
    },
  },
  data() {
    return {
      currentSort: "number",
      currentSortDir: "desc",
      headers: [
        { field: "number", name: this.$filters.localize("tableColumns.common.number") },
        { field: "fulfillmentKind", name: this.$filters.localize("tableColumns.common.fulfillmentKind") },
        { field: "recipient", name: this.$filters.localize("tableColumns.ordersBot.recipient") },
        { field: "status.name", name: this.$filters.localize("tableColumns.common.status_name") },
      ],
      rows: [],
      filters: [],
      filter: {
        type: "",
        value: null,
        field: "",
      },
      filterTypes: [
        { name: "Дорівнює", value: "Equal", char: "=", type: "all" },
        { name: "Не дорівнює", value: "NotEqual", char: "<>", type: "all" },
        { name: "Більше", value: "More", char: ">", type: "number, date" },
        { name: "Менше", value: "Less", char: "<", type: "number, date" },
        { name: "Включає", value: "Contains", char: "включає", type: "string" },
        { name: "Виключає", value: "NotContains", char: "виключає", type: "string" },
      ],
      fields: [
        { field: "number", name: this.$filters.localize("tableColumns.common.number"), type: "number" },
        {
          field: "fulfillmentKind",
          name: this.$filters.localize("tableColumns.ordersBot.orderType"),
          type: "lookup",
          lookup: [
            { id: "Standard", name: this.$filters.localize("OrderPage.fulfillmentKind.standard") },
            { id: "Tailoring", name: this.$filters.localize("OrderPage.fulfillmentKind.tailoring") },
          ],
        },
        { field: "recipientPhone", name: this.$filters.localize("tableColumns.common.recipientPhone"), type: "string" },
        { field: "recipient", name: this.$filters.localize("tableColumns.common.recipient"), type: "string" },
      ],
    };
  },
  watch: {
    filters: {
      handler() {
        this.loadRows();
      },
      deep: true,
    },
  },
  methods: {
    openOrder(row, openInNewTab = false) {
      const route = {
        name: "OrderBotPage",
        params: {
          id: row.id,
          ...(row.kind ? { kind: row.kind } : {}),
        },
        query:
          row.fulfillmentKind === "Tailoring"
            ? { fulfillmentKind: "Tailoring" }
            : {},
      };

      if (openInNewTab) {
        const routeData = this.$router.resolve(route);
        window.open(routeData.href, "_blank");
        return;
      }

      this.$router.push(route);
    },
    createOrder(kind = "Wholesale", fulfillmentKind = "Standard") {
      const params = { id: uuidv4() };
      const query = {};

      if (kind) {
        params.kind = kind;
      }

      if (fulfillmentKind && fulfillmentKind !== "Standard") {
        query.fulfillmentKind = fulfillmentKind;
      }

      this.$router.push({
        name: "OrderBotPage",
        params,
        query,
      });
    },
    getFulfillmentKind(row) {
      return row?.fulfillmentKind || "Standard";
    },
    formatFulfillmentKind(row) {
      return this.getFulfillmentKind(row) === "Tailoring" ? "Відшив" : "Замовлення";
    },
    getFulfillmentKindClass(row) {
      return this.getFulfillmentKind(row) === "Tailoring"
        ? "bot-order-chip--tailoring"
        : "bot-order-chip--standard";
    },
    isChipHeader(header) {
      return header.field === "fulfillmentKind" || header.field === "status.name";
    },
    getStatusId(row) {
      return row?.statusId || row?.status?.id;
    },
    getStatusClass(row) {
      switch (this.getStatusId(row)) {
        case "1bf61851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--new";
        case "2bf61851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--reserv";
        case "3bf61851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--wait";
        case "4bf61851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--confirm";
        case "5bf61851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--on-the-way";
        case "6bf61851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--close";
        case "7bf61851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--refund";
        case "8bf61851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--cancel";
        case "9bf61851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--resort";
        case "0bf62851-347c-4d0d-a62e-d488dce9c0da":
          return "bot-status-chip--wait-confirm";
        case "124f7ab2-9af9-45af-9e66-3fefc9fca101":
          return "bot-status-chip--tailoring-confirmed";
        case "8d48c2f5-767e-45f8-a0b7-675f6cb8efb0":
          return "bot-status-chip--tailoring-production";
        case "ec6d3806-1d41-4de1-a4ff-2fd9d93f0eef":
          return "bot-status-chip--tailoring-ready";
        default:
          return "bot-status-chip--default";
      }
    },
    getMargin(row) {
      return (
        Number(this.getRowValue(row, { field: "cashPaidAmount" })) +
        Number(this.getRowValue(row, { field: "bonusPaidAmount" })) +
        Number(this.getRowValue(row, { field: "paymentAmount" })) -
        Number(this.getRowValue(row, { field: "totalCost" }))
      );
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("uk-UA", {
        style: "currency",
        currency: "UAH",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(Number(value || 0));
    },
    loadRows() {
      this.$http
        .post(
          window.location.origin + "/api/v1/order/orders",
          this.filters.map((x) => ({
            Value: x.value,
            Field: x.field,
            Operation: x.type,
          }))
        )
        .then((response) => {
          this.rows = response.data.data;
        });
    },
    typesFilterfilter(filter) {
      if (filter.field) {
        const type = this.fields.find((x) => x.field == filter.field)?.type ?? "all";
        return this.filterTypes.filter((x) => x.type == "all" || x.type.includes(type));
      }
      return [];
    },
    currentInputType(filter) {
      if (filter.field) {
        const type = this.fields.find((x) => x.field == filter.field)?.type ?? "all";
        return type == "all" ? "text" : type;
      }
      return "text";
    },
    addFilter(filter) {
      this.filters.push(filter);
      localStorage.setItem(this.schemaName, JSON.stringify(this.filters));
      this.filter = {
        type: "",
        value: null,
        field: "",
      };
      this.loadRows();
    },
    removeFilter(indexFilter) {
      this.filters = this.filters.filter((_, index) => index !== indexFilter);
      localStorage.setItem(this.schemaName, JSON.stringify(this.filters));
      this.loadRows();
    },
    clearFilters() {
      this.filters = [];
      localStorage.removeItem(this.schemaName);
    },
    getFilterString(filter) {
      return this.fields.find((x) => x.field == filter.field)?.name;
    },
  },
  mounted() {
    this.loadRows();
  },
};
</script>

<style scoped>
.bot-section {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bot-toolbar,
.bot-active-filters,
.bot-table-card {
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 38, 65, 0.05);
}

.bot-toolbar {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 10px;
  padding: 10px;
  align-items: start;
}

.bot-toolbar__actions {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.bot-filter {
  display: grid;
  grid-template-columns: minmax(130px, 1fr) minmax(130px, 1fr) minmax(140px, 1fr) auto;
  gap: 8px;
}

.bot-control {
  min-height: 34px;
  border-color: #d9e2ec;
  border-radius: 8px;
  font-weight: 600;
}

.bot-action {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 8px;
  font-size: 0.74rem;
  font-weight: 800;
  white-space: nowrap;
}

.bot-action i {
  width: 16px;
  display: inline-flex;
  justify-content: center;
}

.bot-action--primary {
  color: #0f7a3a;
  border-color: #86d99a;
  background: #f0fdf4;
}

.bot-action--tailoring {
  color: #0f766e;
  border-color: #7dd3c7;
  background: #f0fdfa;
}

.bot-action--filter {
  color: #173b5d;
  border-color: #d9e2ec;
  background: #f7fafc;
}

.bot-active-filters {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 10px;
  padding: 10px;
}

.bot-filter-chip {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  padding: 10px;
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  background: #f7fafc;
}

.bot-filter-chip__label {
  padding-right: 32px;
  color: #173b5d;
  font-weight: 800;
}

.bot-filter-chip__remove {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9e2ec;
  border-radius: 8px;
  color: #526171;
  background: #ffffff;
}

.bot-table-card {
  position: relative;
  min-height: 0;
  flex: 1;
  overflow: auto;
  box-shadow: 0 14px 30px rgba(15, 38, 65, 0.08);
  -webkit-overflow-scrolling: touch;
}

.bot-table {
  min-width: 760px;
  margin-bottom: 0;
}

.bot-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  border-bottom: 1px solid #dfe7f0;
  color: #526171;
  background: #f7fafc;
  font-size: 0.76rem;
  text-transform: uppercase;
  white-space: nowrap;
}

.bot-table td {
  vertical-align: middle;
}

.bot-table__link-cell {
  cursor: pointer;
}

.bot-table__chip-cell {
  white-space: nowrap;
}

.bot-order-chip {
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: inherit;
  font-weight: 400;
  line-height: 1.2;
}

.bot-order-chip--standard {
  border: 1px solid #c8d5e2;
  color: #173b5d;
  background: #eef3f8;
}

.bot-order-chip--tailoring {
  border: 1px solid #7dd3c7;
  color: #ffffff;
  background: #0f766e;
}

.bot-status-chip--new,
.bot-status-chip--default {
  border: 1px solid #d6dee8;
  color: #243447;
  background: #eef3f8;
}

.bot-status-chip--reserv {
  color: #ffffff;
  background: #6b7f69;
}

.bot-status-chip--wait {
  color: #ffffff;
  background: #8500b9;
}

.bot-status-chip--confirm {
  border: 1px solid #f2d46b;
  color: #513f00;
  background: #fff7d6;
}

.bot-status-chip--on-the-way,
.bot-status-chip--tailoring-ready {
  color: #ffffff;
  background: #16a34a;
}

.bot-status-chip--close {
  color: #ffffff;
  background: #5e5e5e;
}

.bot-status-chip--refund {
  color: #ffffff;
  background: #693b3b;
}

.bot-status-chip--cancel,
.bot-status-chip--resort {
  color: #ffffff;
  background: #8f3030;
}

.bot-status-chip--wait-confirm {
  color: #ffffff;
  background: #239ef0;
}

.bot-status-chip--tailoring-confirmed {
  color: #ffffff;
  background: #0f766e;
}

.bot-status-chip--tailoring-production {
  color: #ffffff;
  background: #2563eb;
}

.bot-empty {
  padding: 24px;
  color: #7b8794;
  text-align: center;
  font-weight: 700;
}

@media (max-width: 767.98px) {
  .bot-section {
    gap: 8px;
  }

  .bot-toolbar {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 10px 12px;
  }

  .bot-toolbar__actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bot-action {
    width: 100%;
    min-height: 31px;
    font-size: 0.72rem;
  }

  .bot-filter {
    grid-template-columns: 1fr;
  }

  .bot-active-filters {
    grid-template-columns: 1fr;
    padding: 10px 12px;
  }

  .bot-filter-chip {
    padding: 10px 12px;
  }

  .bot-filter .bot-control,
  .bot-filter-chip .bot-control {
    font-size: 16px;
  }
}
</style>
